import React from 'react'
import PropTypes from 'prop-types'
import { RatingUtil } from './ratingUtils'
import { classifyRating } from './classifyRating'

const RatingPropTypes = {
  rating: PropTypes.number
}

type RatingProps = PropTypes.InferType<typeof RatingPropTypes>

const renderRating = (rating: number): React.ReactElement => {
  const roundedRating = RatingUtil.round(rating)

  return (
    <>
      <span className={classifyRating(roundedRating)}>{roundedRating}</span>
      <span>/5</span>
    </>
  )
}

const renderNoRating = (): React.ReactElement => (
  <span className={classifyRating(null)}>N/A</span>
)

const renderContent = (rating: number): React.ReactElement => {
  if (rating == null) {
    return renderNoRating()
  } else {
    return renderRating(rating)
  }
}

export const Rating = ({ rating }: RatingProps): React.ReactElement => {
  return (
    <span data-testid='rating'>
      {renderContent(rating)}
    </span>
  )
}

Rating.propTypes = RatingPropTypes
